export default __webpack_public_path__ + "static/media/d109ab52ee617189fe750c0abcf59985.svg";